import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

const DesktopView = styled.div`
  display: block;
  @media (max-width: 700px) {
    display: none;
  }
`;

const MobileView = styled.div`
  display: none;
  @media (max-width: 700px) {
    display: block;
  }
`;

const ResponsiveContainer = ({ desktopComponent, mobileComponent, children }) => {
  return (
    <React.Fragment>
      <DesktopView>{desktopComponent || children}</DesktopView>
      <MobileView>{mobileComponent || children}</MobileView>
    </React.Fragment>
  );
};

ResponsiveContainer.propTypes = {
  desktopComponent: PropTypes.node,
  mobileComponent: PropTypes.node,
  children: PropTypes.node,
};

export default ResponsiveContainer;



// WEBPACK FOOTER //
// ./src/design-system/layout/ResponsiveContainer/ResponsiveContainer.jsx